import Header from "./header-list";
import Pagination from "./pagination";
import { FaTimes } from "react-icons/fa";
import { convertToMoney } from "~/common/utils/currency";

function Pill({ value, onRemove }) {
  return (
    <div className="bg-gray-400  text-white rounded-md px-1 py-1 text-sm flex gap-2">
      {value}
      <button onClick={onRemove}>
        <FaTimes fontSize={12} />
      </button>
    </div>
  );
}

function QueryContainer({ queries, onRemoveQuery }) {
  let rangeYear = undefined;
  let rangePrice = undefined;
  const findedLteYear = queries?.find((f) => f.key === "lte-year");
  const findedGteYear = queries?.find((f) => f.key === "gte-year");
  const findedLtePrice = queries?.find((f) => f.key === "lte-price");
  const findedGtePrice = queries?.find((f) => f.key === "gte-price");

  if (findedLteYear && findedGteYear) {
    rangeYear = `${findedLteYear.value} : ${findedGteYear.value}`;
  }

  if (findedLtePrice && findedGtePrice) {
    rangePrice = `${convertToMoney(
      Number(findedGtePrice.value)
    )} : ${convertToMoney(Number(findedLtePrice.value))}`;
  }

  const toExclude = ["lte-year", "gte-year", "lte-price", "gte-price"];

  const filterQueries = queries?.filter((q) => {
    return !toExclude.includes(q.key);
  });

  return (
    <div className="flex  gap-2">
      {rangeYear && (
        <Pill
          value={rangeYear}
          onRemove={() =>
            onRemoveQuery({ key: "range-year", value: rangeYear })
          }
        />
      )}

      {rangePrice && (
        <Pill
          value={rangePrice}
          onRemove={() =>
            onRemoveQuery({ key: "range-price", value: rangePrice })
          }
        />
      )}
      {filterQueries?.map((q) => {
        const { key, value } = q;
        return (
          <Pill
            key={key}
            value={value}
            onRemove={() => onRemoveQuery({ key, value })}
          />
        );
      })}
    </div>
  );
}

export default function Container({
  children,
  currentPage,
  initialSortValue,
  pages,
  onChangedPage,
  onNextClick,
  onPrevClick,
  onSortApply,
  queries,
  onRemoveQuery,
}) {
  return (
    <div className="flex flex-col gap-4">
      <Header
        initialSortValue={initialSortValue}
        onSortChange={onSortApply}
        currentPage={currentPage}
        onChangedPage={onChangedPage}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        pages={pages}
      />
      <QueryContainer onRemoveQuery={onRemoveQuery} queries={queries} />
      {children}
      <Pagination
        currentPage={currentPage}
        onChangedPage={onChangedPage}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        pages={pages}
      />
    </div>
  );
}
